// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cell-changed {\n  background-color: #fff3cd;\n  font-weight: 600;\n  padding: 2px 4px;\n  border-radius: 3px;\n}\n\n.change-row td {\n  background-color: #f8f9fa;\n  border-left: 3px solid #ffc107;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
